import { createSlice } from "@reduxjs/toolkit";

import { STATUS } from "../../../config/constants";

const initialState = {
  data: {},
  status: STATUS.NONE,
};

export const deleteAccountSlice = createSlice({
  name: "deleteAccount",
  initialState,
  reducers: {
    resetState: (state) => {
      state.status = STATUS.NONE;
      state.data = undefined;
    },
    readyForNextState: (state) => {
      state.status = STATUS.NONE;
      state.error = undefined;
    },
    request: (state) => {
      state.status = STATUS.FETCHING;
    },
    success: (state) => {
      state.status = STATUS.SUCCESS;
    },
    failure: (state, action) => {
      const { payload: error } = action;
      state.status = STATUS.FAILURE;
      state.error = error;
    },
  },
});

export const { resetState, readyForNextState, request, success, failure } =
  deleteAccountSlice.actions;

export const status = (state) => state.deleteAccount.status;

export const data = (state) => state.deleteAccount.data;

export const error = (state) => state.deleteAccount.error;

export default deleteAccountSlice.reducer;
